import {
  ACCOUNT_SUBSCRIPTIONS_ALL,
  ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_CREATE,
  ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_DELETE,
  ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_GET,
  ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_UPDATE,
  ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS
} from '../constants/AccountSubscriptions';

const initialState = {
    accountSubscription: {
      id: null,
      name: '',
      color: '',
    },
    accountSubscriptions: null,
  }
  
  const accountSubscriptions = (state = initialState, action) => {
    switch (action.type) {
      case ACCOUNT_SUBSCRIPTIONS_ALL:
        return {
          ...state,
        }
      case ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS:
        return {
          ...state,
          accountSubscriptions: action.subscriptions,
        }
      case ACCOUNT_SUBSCRIPTIONS_GET:
        return {
          ...state,
        }
      case ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS:
        return {
          ...state,
          accountSubscription: action.subscription,
        }
      case ACCOUNT_SUBSCRIPTIONS_CREATE:
        return {
          ...state,
        }
      case ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS:
        return {
          ...state,
          accountSubscriptions: [
            ...state.accountSubscriptions,
            action.subscriptions,
          ],
        }
      case ACCOUNT_SUBSCRIPTIONS_UPDATE:
        return {
          ...state,
        }
      case ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS:
        return {
          ...state,
          accountSubscription: action.subscription,
          accountSubscriptions: state.accountSubscriptions.map(t => {
            if (action.subscriptions.id === t.id) {
              return action.subscriptions;
            }
            return t;
          })
        }
      case ACCOUNT_SUBSCRIPTIONS_DELETE:
        return {
          ...state,
        }
      case ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS:
        return {
          ...state,
          accountSubscriptions: state.accountSubscriptions
            ? state.accountSubscriptions.filter(t => t.id !== action.subscription)
            : [],
        }
      default:
        return state;
    }
  }
  
  export default accountSubscriptions;